/******************************************************************
 * Archivo : client/src/queries/fetchAllUsers.js
 * Proyecto: CB30
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query AllUsersQuery {
    users {
      id
      email
      nombre
      apellido
      validated
      active
      tipoPerfil
      
      roles {
        id
        code
        label
      }

      person {
        documento_de_identidad
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchAllUsers.js